"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFromTeams = exports.selectTeams = void 0;
var Team_B_med_svg_1 = __importDefault(require("@ClientAssets/icons/Team_B_med.svg"));
var lodash_1 = __importDefault(require("lodash"));
function selectTeams(createUi, showDecideModal, userTeamsManager, multiSelectDropdownFactory, noop, telemetry, userList) {
    var selectedTeamsMap = userTeamsManager.getSelectedTeamsMap();
    var selectedTeamsStore = {};
    lodash_1.default.forEach(selectedTeamsMap, function (team) {
        selectedTeamsStore[team.id] = {
            id: team.id,
            name: team.name,
            selected: team.selected > 0,
        };
    });
    var ui = createUi(require("./SelectModal.html"), {
        selectDropdown: multiSelectDropdownFactory.create(selectedTeamsMap, noop, {
            title: "Which teams will they be joining?",
            icon: Team_B_med_svg_1.default,
        }),
    });
    return showDecideModal({
        title: "Add to a team",
        explainer: ui,
        yesButton: "Let's do this",
        noButton: "cancel",
    }).then(function (confirmed) {
        var e_1, _a;
        if (confirmed) {
            userTeamsManager.updateUserTeams(selectedTeamsMap);
            var _loop_1 = function (userId) {
                var user = userList.find(function (u) { return u._id === userId; });
                var role = "creator";
                if (user && user.roles && user.roles[0] && user.roles[0].name) {
                    role = user.roles[0].name;
                }
                telemetry.trackOnly("Teams Updated", {
                    user_teams_membership_type: role,
                    user_teams_membership_origin: "checkbox existing",
                    user_teams_membership_number: userTeamsManager.getUsersTeams(userId).length,
                }, { blockIntercom: true });
            };
            try {
                for (var _b = __values(userTeamsManager.getAllSelectedUserIds()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var userId = _c.value;
                    _loop_1(userId);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    });
}
exports.selectTeams = selectTeams;
function removeFromTeams(createUi, showDeleteModal, userTeamsManager) {
    var ui = createUi(require("./RemoveModal.html"), {});
    return showDeleteModal({
        title: "Remove from team?",
        explainer: ui,
        deleteButton: "Got it!",
        cancelButton: "cancel",
    }).then(function (confirmed) {
        if (confirmed) {
            return userTeamsManager.removeSelectedUsersFromAllTeams();
        }
        else {
            return;
        }
    });
}
exports.removeFromTeams = removeFromTeams;
